



$(document).ready(function(){


$(function() {
$(".sub_grand_menu_top").click(function(){
$(".sub_grand_menu_top .button-navi-icon").addClass("close");
$(".button-close").css('z-index', '9999');
$("html, body").css('overflow', 'hidden');
$(".menu_back").css('z-index', '999');
$("#menu_index").fadeIn();
$('#sp_header').removeClass("active");
});
});




$(function() {
$(".button-close").click(function(){
$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
$(".button-close").css('z-index', '-9999');
$(".menu_back").css('z-index', '-99');
$("html, body").css('overflow', 'visible');
$("#menu_index").fadeOut();
$('#sp_header').addClass("active");
});
});
  
  
  

  
  
		
		$(function() {
				$(".gra_list a").click(function(){
						$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
						$(".button-close").css('z-index', '-9999');
                  $(".menu_back").css('z-index', '-99');
						$("html, body").css('overflow', 'visible');
						$("#menu_index").fadeOut();
						$('#sp_header').addClass("active");
				});
		});


  
  $(function() {
$(".menu_back").click(function(){
$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
$(".button-close").css('z-index', '-9999');
$("html, body").css('overflow', 'visible');
$("#menu_index").fadeOut();
$('#sp_header').addClass("active");
});
});
  
  


$(function() {
$(".menus a").click(function(){
$(".button-navi-icon").removeClass("close");
$("html, body").css('overflow', 'visible');
$("#menu_index").fadeOut();
$("#about_page").fadeIn();
$(".button-close").css('z-index', '-9999');
$('#sp_header').addClass("active");
});
});

  
// blog menu
$(function() {
  $(".mod_blog_menu__open").click(function(){
    $("html, body").css('overflow', 'hidden');
    $(".mod_blog_menu__contents").fadeIn();
    $('#sp_header').removeClass("active");
  });
});
$(function() {
  $(".mod_blog_menu__close").click(function(){
    $("html, body").css('overflow', 'visible');
    $(".mod_blog_menu__contents").fadeOut();
    $('#sp_header').addClass("active");
  });
});



$(window).on('scroll',function(){
var winPosTop = $(window).scrollTop();
if(winPosTop >= 300){
					$('#menu_scroll, .page_top, .page_top_sp, .slide_text').addClass("active");
} else if(winPosTop < 300){
					$('#menu_scroll, .page_top, .page_top_sp, .slide_text').removeClass("active");
}
});
  
  
      $(window).on('scroll',function(){
    var winPosTop = $(window).scrollTop();
    if(winPosTop >= 300){
            $('.top_guide').fadeIn(1200);
    } else if(winPosTop < 300){
            $('.top_guide').fadeOut();
    }
    });
  

			
		
		$('.gra_list a, .top_scroll a, .page_top_sp a').click(function(){
				var target = $(this.hash);
				//$(this).text(target.length+"/");
				if (target) {
					var targetOffset = target.offset().top;
					$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
				return false;}
		});

});



			(function($){
					window.sr = ScrollReveal({ reset: false ,mobile: true});
					sr.reveal( '.st_ami', { origin: 'bottom' , distance: '1%', duration: 1000 , scale: 1.0, delay :200,opacity: 0, easing:'cubic-bezier(0.78, .18, .34, .98)',});
})(jQuery);












